export default [
  {
    name: 'bittorrentv2',
    displayName: 'BitTorrent',
    displayTicker: 'BTT',
    decimals: 18,
    ticker: 'BTTNEW',
    address: 'TAFjULxiVgT4qWk6UZwjqwZXTSaGaqnVp4',
    tokenType: 'TRC20',
    info: {
      description:
        "BitTorrent Token is aiming to tokenize one of the world's largest decentralized networks: BitTorrent, a file sharing protocol responsible for up to 40% of daily Internet traffic. The token will first be used to pay for faster downloads before other use cases like censorship-resistant content distribution, storage, and proxying services are introduced.",
      reddit: 'https://www.reddit.com/r/BittorrentToken',
      twitter: 'https://twitter.com/BitTorrent',
      website: 'https://bittorrentchain.io/',
      telegram: 'https://t.me/BitTorrentChain',
    },
    primaryColor: '#787878',
    gradientColors: ['#787878', '#525252'],
    gradientCoords: { x1: '91.53%', y1: '101%', x2: '10.067%', y2: '0%' },
  },
  {
    name: 'just_tron',
    displayName: 'JUST',
    decimals: 18,
    ticker: 'JSTTRX',
    displayTicker: 'JST',
    address: 'TCFLL5dx5ZJdKnWuesXxi1VPwjLVmWZZy9',
    tokenType: 'TRC20',
    info: {
      description:
        'JST is the governance token for JUST, a DeFi lending platform built on the TRON blockchain. JST can also be used for the variety of products and services in the JUST ecosystem.',
      twitter: 'https://twitter.com/defi_just',
      website: 'https://just.network/',
      telegram: 'https://t.me/just_defi',
    },
    primaryColor: '#F15656',
    gradientColors: ['#F15656', '#AF170D'],
    gradientCoords: { x1: '3%', y1: '5.5%', x2: '31%', y2: '36.5%' },
  },
  {
    name: 'sun_tron',
    displayName: 'Sun (New)',
    decimals: 18,
    ticker: 'SUNTRX',
    displayTicker: 'SUN',
    address: 'TSSMHYeV2uE9qYH95DqyoCuNCzEL1NvU3S',
    tokenType: 'TRC20',
    info: {
      description:
        'Sun is a multifunctional governance token on SUN.io, a platform that offers stablecoin swap, yield farming, and self-governance on the TRON network.',
      twitter: 'https://twitter.com/defi_sunio',
      website: 'https://sun.io/',
      telegram: 'https://t.me/SunIO_Defi',
    },
    primaryColor: '#9567F8',
    gradientColors: ['#9567F8', '#4504FE'],
    gradientCoords: { x1: '3%', y1: '5.5%', x2: '31%', y2: '36.5%' },
  },
  {
    name: 'tetherusd_tron',
    displayName: 'Tether USD',
    decimals: 6,
    ticker: 'USDTTRX',
    displayTicker: 'USDT',
    address: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
    tokenType: 'TRC20',
    primaryColor: '#53AE94',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'usdd_tron',
    displayName: 'USDD',
    decimals: 18,
    ticker: 'USDD',
    address: 'TPYmHEhy5n8TCEfYGqW2rPxsghSfzghPDn',
    tokenType: 'TRC20',
    info: {
      description:
        'USDD is a decentralized, overcollateralized, and chain-agnostic stablecoin pegged to the U.S. Dollar. While the TRON DAO Reserve ensures the stability of USDD, the asset is designed to be tamper-proof and never controlled by a centralized organization.',
      twitter: 'https://twitter.com/usddio',
      website: 'https://usdd.io/',
      telegram: 'https://t.me/usddio',
    },
    primaryColor: '#49AB91',
    gradientColors: ['#216C58', '#49AB91'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'usdcoin_tron',
    displayName: 'USDC',
    decimals: 6,
    ticker: 'USDCTRX',
    displayTicker: 'USDC',
    address: 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8',
    tokenType: 'TRC20',
    info: {
      description:
        'USDC (USDC) is a dollar digital currency that offers frictionless, secure and interoperable access to capital markets, global trade, payments and modern commerce.',
      website: 'https://tron.network/usdc',
    },
    primaryColor: '#3E90E8',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
]
